import React from "react";
import AcxChip from "./AcxChip";
import { Grid, Tooltip } from "@mui/material";
import AcxButton from "./AcxButton";
import AcxMainTextField from "components/UI/AcxMainTextField";
import theme from "Theme/AppTheme";

interface OwnProps {
    size: "small" | "medium";
    color: "green" | "red" | "blue" | "gray";
    tooltip?: React.ReactNode;
    values?: string[];
    value?: string;
    placeholderText?: string;
    isDisabled?: boolean;
    btnDisabled?: boolean;
    labelText?: string;
    loading?: boolean;
    onDelete?: (value: string) => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onClick?: () => void;
}

const AcxChipListInput = (props: OwnProps) => {
    return (
        <Grid
            container
            item
            alignItems="center"
            style={{ marginTop: "0.5rem" }}
        >
            <Tooltip title={props.tooltip ?? ""}>
                <Grid item>
                    <AcxMainTextField
                        isDisabled={props.isDisabled}
                        showAllErrors
                        onChange={props.onChange}
                        id="chip-list-input"
                        labelText={props.labelText}
                        placeholderText={props.placeholderText}
                        value={props.value}
                        containerStyle={{
                            width: "190px",
                        }}
                        textContainerSx={{
                            marginRight: 0,
                            height: "32px",
                        }}
                        type="text"
                    />
                </Grid>
            </Tooltip>
            <AcxButton
                style={{
                    marginRight: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                }}
                loading={props.loading}
                onClick={props.onClick}
                disabled={props.btnDisabled}
                containerStyle={{ width: "min-content", top: "10px" }}
                color="primary"
            >
                Add
            </AcxButton>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    maxWidth: "100%",
                    marginTop: "0.5rem",
                    width: "100%",
                    overflow: "hidden",
                }}
            >
                {props.values &&
                    props.values?.map((value) => (
                        <div
                            key={`${value}`}
                            style={{ flexShrink: 1, overflow: "hidden" }}
                        >
                            <AcxChip
                                key={value}
                                size={props.size}
                                color={props.color}
                                label={value}
                                onDelete={() =>
                                    props.onDelete && props.onDelete(value)
                                }
                                style={{ marginRight: 10 }}
                            />
                        </div>
                    ))}
            </div>
        </Grid>
    );
};

export default AcxChipListInput;
